export const environment = {
  production: true,
  apiURL: "https://api.crecosa.com:8595/",
  apiCredit: "https://api.crecosa.com:8785/credit/",
  guaranteeUrl: "https://api.crecosa.com:8785/guarantee/api/",
  apiReports: "https://api.crecosa.com:8785/report-credit/",
  uiBackOffice: "https://backoffice-crecosa.web.app/#/home/",
  reportGarMobiliaria: "https://api.crecosa.com/contrato/ContratoCtpaga/contratoctpaga.html",
};
